import { OptionTabColor, OptionTabs } from '@brunommsilva/react-foundations';
import { useTranslation } from 'react-i18next';

import { TransactionType } from '../../models/transactions';
import getCurrencyColor from './currency-color';

interface Props {
  selected?: TransactionType;
  onSelected: (type: TransactionType) => void;
}

const TransactionTypeTabs = ({ selected, onSelected }: Props) => {
  const { t } = useTranslation();

  const options = Object.values(TransactionType).map((type) => ({
    value: type,
    label: t(`TRANSACTION_TYPE_${type}`),
    color: getCurrencyColor(type) as OptionTabColor,
  }));

  return (
    <OptionTabs
      options={options}
      selected={selected}
      onSelected={onSelected}
      label={t('TRANSACTION_TYPE')}
    />
  );
};

export default TransactionTypeTabs;
